import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  FormGroup,
} from "reactstrap";
import { FaUpload, FaCloudDownloadAlt, FaSpinner } from "react-icons/fa";
import { addLoad, getLoads } from "../../../actions/loads";
import { connect } from "react-redux";
import * as XLSX from "xlsx";
import InfoAlert from "../../../components/Modals/InfoAlert";

export const UploadData = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [label, setLabel] = useState("");

  const toggle = () => setIsOpen(!isOpen);

  const onDrop = useCallback(
    (acceptedFiles) => {
      setShowSpinner(true);
      setTimeout(() => {
        acceptedFiles.forEach((file) => {
          const reader = new FileReader();
          reader.onload = (evt) => {
            const bstr = evt.target.result;
            const wb = XLSX.read(bstr, { type: "binary" });

            let formData = new FormData();
            formData.append("name", label);
            formData.append("file", file);
            if (label === "") {
              InfoAlert("Label cannot be empty");
            } else {
              props.addLoad(formData, setIsOpen, props.getLoads);
            }

            setShowSpinner(false);
          };
          reader.readAsBinaryString(file);
        });
      }, 100);
    },
    [label]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: ".xlsx, .xls",
  });

  return (
    <div style={{ marginTop: 35 }}>
      <Button
        style={{
          float: "right",
          padding: "2px 11px 2px 11px",
          backgroundColor: "#6BA4FA",
          borderColor: "#6BA4FA",
          boxShadow: "none",
        }}
        onClick={toggle}
      >
        <FaUpload
          style={{ marginRight: 8, marginTop: "-5px", fontSize: 13 }}
        ></FaUpload>
        <span style={{ fontSize: 14 }}> Upload</span>
      </Button>
      <Modal isOpen={isOpen} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>{props.activeTab}</ModalHeader>
        {showSpinner ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "40px 0px",
            }}
          >
            <FaSpinner
              icon="spinner"
              className="spinner"
              style={{
                fontSize: 30,
                display: "flex",
                justifyContent: "center",
              }}
            />
          </div>
        ) : (
          <ModalBody style={{ padding: "15px 20px" }}>
            <b>Upload an excel file and assign a short name to the Load.</b>

            <FormGroup style={{ marginTop: 20 }}>
              <Label for="label">Assign a short label (max 64 char)</Label>
              <Input
                type="text"
                name="label"
                id="label"
                value={label}
                onChange={(e) => setLabel(e.target.value)}
                style={{ width: 250 }}
                maxLength="20"
              />
            </FormGroup>
            <div style={{ padding: "10px 10px 15px 10px" }}>
              <div
                {...getRootProps({ className: "dropzone" })}
                // style is managed here when dragging, while without dragging is in App.css
                style={
                  isDragActive
                    ? {
                        borderColor: "#4eacfe",
                        background: "rgba(76, 192, 243, 0.1)",
                      }
                    : null
                }
              >
                <div>
                  <FaCloudDownloadAlt
                    style={{ fontSize: 50, color: "#9C9EA4" }}
                  ></FaCloudDownloadAlt>
                  <h5 style={{ fontWeight: 400, marginTop: 15 }}>
                    Upload your file
                  </h5>
                  <p style={{ color: "gray" }}>
                    Press here to <span className="text-primary">browse</span>{" "}
                    for a file to upload.
                  </p>
                  <p className="small" style={{ color: "gray" }}>
                    XLSX and XLS. Please make sure to load a file with
                    predefined structure. Only 1 file is accepted
                  </p>
                </div>
                <input {...getInputProps()} />
              </div>
            </div>
          </ModalBody>
        )}

        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, { addLoad, getLoads })(UploadData);
